import "babel-polyfill"
import { iStorage, iRem } from 'smart-core-util'
iRem.install(document, window)


import Vue from 'vue'
import App from './App'
import router from './router'

import axios from './api/axios'
import api from './api/api'
import bus from './assets/js/bus'


import SmartUi from 'smart_webview_ui'

import 'smart_webview_ui/src/assets/js/rem.js' 
import 'smart_webview_ui/src/assets/iconfont/iconfont.css'  


import './common/filter/filter' 

import DatetimePlugin from 'vux/src/plugins/datetime/index.js'


Vue.use(DatetimePlugin)

Vue.config.productionTip = false


const FastClick = require('fastclick')
FastClick.attach(document.body)

import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(Mint);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import { Toast, MessageBox } from 'mint-ui'

import 'weui/dist/style/weui.min.css'
import "smart-filer/dist/smart-filer.min.css";
import './assets/sass/variable.scss'
import './assets/sass/reset.scss'
import './assets/sass/default.scss' 


import store from './store/store'


import iJsBridge from './common/JSbridge'

import nativeJsBridge from './common/nativeJsBridge'


Vue.prototype.axios = axios
Vue.prototype.api = api
Vue.prototype.storage = iStorage

Vue.prototype.Bus = bus

Vue.prototype.$toast = Toast
Vue.prototype.$messagebox = MessageBox
Vue.prototype.iStorage = iStorage;
Vue.prototype.iJsBridge = new iJsBridge({ alert: Toast });
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();

/* eslint-disable no-new */
iStorage.install().then(() => {

axios.defaults.baseURL = iStorage.getUrlGateway();
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})
})



// WEBPACK FOOTER //
// ./src/main.js